<template>
  <div>
    <div class="row my-1" v-for="(item, index) of items" :key="index">
      <div class="col-md-4" v-if="loaded">
        <select-component class="form-control" name="causa" v-model="item.causa">
          <option value>Selecione a causa</option>
          <option v-for="option of options" :key="option.cod_causa" :value="option.cod_causa">{{ option.nome }}</option>
          
        </select-component>
      </div>
      <div class="col-md-4">
        <input
          type="tel"
          v-numeric
          v-model="item.cond_total"
          class="form-control"
          placeholder="Condenação total (qtd.)"
        />
      </div>
      <div class="col-md-3">
        <input
          type="tel"
          v-numeric
          v-model="item.cond_parcial"
          class="form-control"
          placeholder="Condenação parcial (qtd.)"
        />
      </div>
      <div class="col-md-1">
        <input
          type="button"
          value="+"
          class="btn-control"
          v-if="index == items.length - 1"
          @click="onAddClick"
        />
        <input
          type="button"
          value="-"
          class="btn-control"
          @click="onRemoveClick(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: false,
      default: () => ([])
    },
  },
  data: () => ({
    items: [],
    options: [],
    loaded: false,
  }),
  methods: {
    onAddClick() {
      this.items.push({});
    },
    onRemoveClick(index) {
      this.items.splice(index, 1);
      if (this.items.length === 0) {
        this.items.push({});
      }
    },
  },
  mounted() {
    this.loaded = false;
    this.items = this.value;
    if (!this.items || !this.value.length) {
      this.items.push({});
    }
    window.api
        .fetch(
          "/acompanhamentos/ant-mortem-aves/load-condenacoes",
          {
            method: "get",
            headers: { "Content-Type": "multipart/form-data" },
          }
        )
        .then((response) => {
          this.options = response.data;
          this.loaded = true;
        })
        .catch((error) => {
          this.$toast.error(
              "Erro ao buscar dados."
            );
        });
  },
};
</script>
<style lang="scss" scoped>
.btn-control {
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  box-shadow: none;
  background: #fc6836;
  font-size: 21px;
  line-height: 21px;
  cursor: pointer;
}
</style>
